import { NOT_AVAILABLE } from 'utils/constants'

export const getPercentage = (value: number, total: number, decimalPlaces: number = 2): string => {
  if (total === 0) return NOT_AVAILABLE
  const percentage = (value / total) * 100
  return percentage.toFixed(decimalPlaces) + '%'
}
